// We can add tracking here in the future
export const redirectToUrl = (url: string) => {
  window.location.assign(url);
};
